import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';

import { FORGOT_PASSWORD_PATH } from '~configs';

export const ForgotPassword = () => {
  const navigate = useNavigate();
  const handleGotoForgotPassword = () => {
    navigate(FORGOT_PASSWORD_PATH);
  };
  return (
    <Typography
      sx={{
        cursor: 'pointer',
        ':hover': { textDecoration: 'underline' },
        width: 'fit-content',
      }}
      color="text.highlight"
      variant="body2"
      fontWeight="500"
      onClick={handleGotoForgotPassword}
    >
      Forgot password?
    </Typography>
  );
};
